import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { cloneDeep } from 'lodash';
import { ConfirmationService } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';

@Component({
  selector: 'app-trainer-impact-tasks',
  templateUrl: './trainer-impact-tasks.component.html',
  styleUrl: './trainer-impact-tasks.component.scss',
})
export class TrainerImpactTasksComponent {
  @Input() courseId: string = '';
  courseData: any;
  isSkelition: boolean = false;
  courseRating: any;

  usersData: any;

  invitationSent: any = [];

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    private router: Router
  ) {}

  ngOnInit() {
    this.isSkelition = true;
    this.getCourseData().then(() => {
      // this.getCourseRating(this.courseId).then(() => {
      //   this.isSkelition = false;
      // });
    });
  }

  async getCourseData() {
    try {
      const res = await this.dataService.getData(`course/impact-trainer-course/${this.courseId}`);
      if (!this.courseId) return;
      if (res.error) {
        console.log(res.msg);
        return;
      }
      this.courseData = res.data[0];

      this.checkInvitationSent(
        this.courseData?.training_request?.impactSettings?.users
      );
      let temp = this.courseData;
      this.usersData = cloneDeep(temp);

      this.usersData =
        this.usersData?.training_request?.impactSettings?.users.map(
          (user: any) => ({
            ...user,
            date: user.date !== undefined ? user.date : null,
            time: user.time !== undefined ? user.time : null,
            zoomLink: user.zoomLink !== undefined ? user.zoomLink : null,
          })
        );

      this.usersData;
      this.invitationSent;
    } catch (e: any) {
      console.log(e);
    }
  }

  checkInvitationSent(users: any[]): void {
    this.invitationSent = [];

    users.forEach((user: any) => {
      if (user.date && user.time && user.zoomLink) {
        this.invitationSent.push(user.userId);
      }
    });

    return this.invitationSent;
  }

  async sendInvite(invitationData: any, newUpdate:any) {
    let temInvitation = cloneDeep(invitationData);

    let tempUpdate = cloneDeep(newUpdate)

    delete tempUpdate?.user
    delete tempUpdate?.survey



    if (!this.courseData?.training_request) return;

    let impactSetting = cloneDeep(this.courseData?.training_request?.impactSettings)

   //debugger

    impactSetting.users = temInvitation.map(({ user, survey, ...rest } : any) => rest);;

    impactSetting.trainers = [ impactSetting.trainers._id ]

    let payload = {
      _id: this.courseData?.training_request._id,
      impactSettings: impactSetting,
      newInviation : tempUpdate
    };

    let res = await this.dataService.postData('training-req/', payload, 'PUT');

    if (res.error) {
      // ur task puchk
    }

    //success wala puck
    this.getCourseData();


  }

  isInvited(user: any) {
    if (this.invitationSent.includes(user.userId)) {
      return true;
    } else return false;
  }

  removeIdFromArray(id: string) {
    this.invitationSent = this.invitationSent.filter(
      (existingId: any) => existingId !== id
    );
  }

  navigateToUrl(params: any) {
    let surveyId = this.courseData?.training_request?.impactSettings.surveyId;
    params.forTrainer = true;
    delete params.surveyID;
    params.courseId = this.courseData._id;
    const queryString = new URLSearchParams(params).toString();
    const url = `/sa/survey/attempt/${surveyId}?${queryString}`;
    window.open(url, '_blank');
}

  isExpired(dateStr:any, timeStr:any){
  const datePart = dateStr?.split('T')[0]; // "YYYY-MM-DD"
  const timePart = timeStr?.split('T')[1]; // "HH:mm:ss.sssZ"
  const combinedDateTimeStr = `${datePart}T${timePart}`;
  const combinedDateTime = new Date(combinedDateTimeStr);
  combinedDateTime.setHours(combinedDateTime.getHours() + 1);
  const currentDateTime = new Date();
  return combinedDateTime < currentDateTime;
  }

  
}